// Where a notification leads, for the in-app bell and push taps alike (v1.0.2 §6c), so the two
// always agree. Null means no page: a trade signal opens a confirm dialog instead.
export function getNotifRoute(n) {
  const m = n.metadata || {};
  switch (n.type) {
    case 'anomaly_detected': {
      const p = new URLSearchParams();
      if (m.txId)     p.set('txId', m.txId);
      if (m.amount)   p.set('amount', String(m.amount));
      if (m.merchant) p.set('merchant', m.merchant);
      return `/expenses?${p}`;
    }
    case 'goal_completed':
      return '/goals';
    case 'automation_failure':
    case 'automation_share':
      return '/automations';
    case 'card_benefits_due':
      return '/expenses#card-benefits';
    case 'rebalance_due': {
      if (!m.accountId) return '/portfolio';
      // A Plaid-linked account opens its read-only view (§6a.9); no source means an Alpaca account.
      const param = m.source === 'plaid' ? 'plaid_account' : 'account_id';
      return `/portfolio?${param}=${encodeURIComponent(m.accountId)}`;
    }
    // Reconnecting a bank happens in Settings (owner, 2026-10-04). bank_connections is the one
    // live notice for every login that needs the user (2026-10-07); the other two are the one-off
    // types it replaced, kept so rows still in a bell route the same way.
    case 'bank_connections':
    case 'plaid_item_error':
    case 'plaid_consent_expiring':
      return '/settings#bank-accounts';
    case 'security_alert':
      return '/settings#security';
    case 'trade_executed':
      return '/portfolio';
    // Settings' "Send test notification": its push opens the button's own section, so a tap
    // checks routing end to end on a real device.
    case 'test':
      return '/settings#preferences';
    case 'privacy_policy_updated':
      return '/privacy';
    // A type this build doesn't know: the native apps embed the web bundle, so a type added on the
    // server later did nothing on tap (the 2026-10-05 Privacy notice on the 10-04 build). The
    // server can send the page as metadata.path; only a path inside this app is followed.
    default:
      return inAppPath(m.path);
  }
}

function inAppPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/')) return null;
  if (path.startsWith('//') || path.includes('\\')) return null;
  return path;
}
